// @flow
import type { CreateSettingsFetcherResult } from 'common/modules/settings-fetcher';
import { createSettingsFetcher } from 'common/modules/settings-fetcher';
import { minimalClientSettings as minimalClientSettingsApi } from './api';
import { MinimalClient } from './models/internal/MinimalClient';

const {
    SettingsFetcher,
    SettingsPrefetcher,
    useSettings,
    getSettings
}: CreateSettingsFetcherResult<MinimalClient> = createSettingsFetcher({
    name: 'minimal-client',
    fetch: async ({ clientId }) => {
        const settings = await minimalClientSettingsApi.fetch({ clientId });
        return MinimalClient.fromJS(settings);
    }
});

export {
    SettingsFetcher as MinimalClientFetcher,
    SettingsPrefetcher as MinimalClientPrefetcher,
    useSettings as useMinimalClient,
    getSettings as getMinimalClient
};
